var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "./jquery-plugins/draggable", "./util"], function (require, exports, draggable_1, util_1) {
    "use strict";
    exports.__esModule = true;
    function move(handler, e, simulated) {
        var de = simulated && simulated.originalEvent ? simulated.originalEvent : (e.originalEvent || e);
        var x = de.clientX;
        var y = de.clientY;
        var type = de.type;
        var $target = $(e.target);
        if (type === 'drag' || type === 'dragover') {
            if (type === 'drag' && de.screenX === 0 && de.screenY === 0) {
                return;
            }
            var handle = type === 'drag' ? e.currentTarget : null;
            if (!handle) {
                var sel = $target.data('active');
                var $handle = $target.find(sel);
                handle = $handle[0];
                e.preventDefault();
            }
            de.dataTransfer.dropEffect = 'move';
            handler(handle, x, y);
        }
        else if (type === 'dragstart') {
            de.dataTransfer.effectAllowed = 'move';
            var handleClass = $target.attr('class');
            var dataIndex = $target.data('index');
            var sel = "." + handleClass + "[data-index=\"" + dataIndex + "\"]";
            console.info("drag start on " + sel);
            $target.data('dragstart', { x: x, y: y });
            $target.trigger('resize:start', sel);
            $target.data('draggingNow', true);
        }
        else if (type === 'drop' || type === 'dragend') {
            if ($target.data('draggingNow')) {
                e.preventDefault();
                e.stopPropagation();
                de.dataTransfer.effectAllowed = 'none';
                $target.removeData('draggingNow');
                $target.trigger('resize:end');
                $target.removeData('dragOrigin');
            }
            return false;
        }
        else {
            console.warn("unhandled drag event " + type);
        }
    }
    ;
    var matrixMatch;
    (function (matrixMatch) {
        matrixMatch[matrixMatch["_all"] = 0] = "_all";
        matrixMatch[matrixMatch["scaleX"] = 1] = "scaleX";
        matrixMatch[matrixMatch["skewY"] = 2] = "skewY";
        matrixMatch[matrixMatch["skewX"] = 3] = "skewX";
        matrixMatch[matrixMatch["scaleY"] = 4] = "scaleY";
        matrixMatch[matrixMatch["tX"] = 5] = "tX";
        matrixMatch[matrixMatch["tY"] = 6] = "tY";
    })(matrixMatch || (matrixMatch = {}));
    ;
    var transformRegex = /matrix\(([\d\.-]+),\s([\d\.-]+),\s*([\d\.-]+),\s*([\d\.-]+),\s*([\d\.-]+),\s*([\d\.-]+)\s*\)/;
    var parseTransformVal = util_1.transformVal(parseFloat);
    var parseTransform = function (transform) {
        var match = transform.match(transformRegex);
        var groups = (match || []).reduce(function (x, g, i) {
            var _a;
            return i > 0 ? __assign({}, x, (_a = {}, _a[matrixMatch[i]] = g, _a)) : x;
        }, {});
        return match ? parseTransformVal(groups) : { scaleX: 1, skewX: 0, skewY: 0, scaleY: 1, tX: 0, tY: 0 };
    };
    exports.transformCss = function (transform) {
        var scaleX = transform.scaleX, scaleY = transform.scaleY, skewX = transform.skewX, skewY = transform.skewY, tX = transform.tX, tY = transform.tY;
        return "matrix(" + scaleX + ", " + skewY + ", " + skewY + ", " + scaleY + ", " + tX + ", " + tY + ")";
    };
    exports.getTransform = function ($cur) {
        var transform = $cur.css('transform');
        return parseTransform(transform);
    };
    function resizable($handles, handler, coverSelector) {
        if (coverSelector === void 0) { coverSelector = 'svg'; }
        var handleMove = move.bind(null, handler);
        $handles.attr('draggable', 'true')
            .on('dragstart', handleMove)
            .on('drop', handleMove)
            .on('dragend', handleMove)
            .draggable();
        if (!draggable_1.isTrident) {
            $handles.on('drag', handleMove);
        }
        else {
            var $cover = $handles.closest(coverSelector);
            $cover.on('dragover', handleMove).on('dragenter', function (e) { e.preventDefault(); });
        }
        return $handles;
    }
    exports.resizable = resizable;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/resize.js
// module id = 40
// module chunks = 0